export default __webpack_public_path__ + "static/media/Body Benefits.fdd62566.png";